import { render, staticRenderFns } from "./techPersonnelForm.vue?vue&type=template&id=6fe9771c&scoped=true&"
import script from "./techPersonnelForm.vue?vue&type=script&lang=js&"
export * from "./techPersonnelForm.vue?vue&type=script&lang=js&"
import style0 from "./techPersonnelForm.vue?vue&type=style&index=0&id=6fe9771c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe9771c",
  null
  
)

export default component.exports